import { theme } from '@prose-ui';
import { styled } from '@prose-ui/legacy';

import { Image } from 'Components/Image';

import playOutlineWhite from 'assets/images/homeRevamp/icon-play-white.svg';
import playOutlineBlack from 'assets/images/play-outline.svg';

import Spacer from './Spacer';
import { Typography } from './Typography';

const ButtonWrapper = styled.div`
  display: flex;
  cursor: pointer;
`;

const ButtonText = styled(Typography)`
  border-bottom: 1px solid;
  border-color: ${theme.colors.accent[200]};
  font-weight: ${theme.typography.fontWeight.medium};
  font-size: ${theme.typography.fontSize.xs};
  color: ${theme.colors.primary[400]};

  &.icon-white {
    color: white;
  }
`;

const StyledIcon = styled(Image)`
  align-self: center;
`;

type YoutubeVideoButtonProps = {
  dataFrom: string;
  dataClick: string;
  buttonText: string;
  onOpenVideo: () => void;
  dataTestId?: string;
  iconWhite?: boolean;
};

export const YoutubeVideoButton = ({
  dataFrom,
  dataClick,
  onOpenVideo,
  buttonText,
  dataTestId,
  iconWhite = false,
}: YoutubeVideoButtonProps) => {
  return (
    <ButtonWrapper
      data-click={dataClick}
      data-from={dataFrom}
      data-testid={dataTestId}
      onClick={onOpenVideo}
    >
      <ButtonText className={iconWhite ? 'icon-white' : ''} upperCase>
        {buttonText}
      </ButtonText>
      <Spacer size={8} />
      <StyledIcon
        alt="Clickable button to see the Prose made just for you campaign video"
        height={20}
        src={iconWhite ? playOutlineWhite : playOutlineBlack}
        width={20}
      />
    </ButtonWrapper>
  );
};
